"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
function useRowActions() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var rowActions = function (cellValue) { return [
        {
            key: "view",
            onClick: function () {
                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.BASKETS_ROUTE).concat(routes_1.VIEW_BASKET_ROUTE, "/").concat(cellValue._id, "/").concat(cellValue.user_id));
            },
        },
    ]; };
    return (0, react_1.useMemo)(function () { return ({
        rowActions: rowActions,
    }); }, [rowActions]);
}
exports.useRowActions = useRowActions;
